import XIcon from "@redotech/redo-icons/x-close.svg";
import classNames from "classnames";
import * as closeXCss from "./redo-button-close-x.module.css";

export enum ButtonSize {
  XSMALL = "xs",
  SMALL = "sm",
  MEDIUM = "md",
  LARGE = "lg",
}

/** NOTE: THIS COMPONENT IS UNTESTED AND I THINK THE STYLES ARE OFF. IT NEEDS A STORYBOOK AND TO BE CLEANED UP*/
export function RedoButtonCloseX({
  onDarkBackground,
  size,
  onclick,
  style,
}: {
  onDarkBackground: boolean;
  size: ButtonSize;
  onclick?: () => void;
  style?: any;
}) {
  return (
    <button
      aria-label="Close modal"
      className={classNames(
        closeXCss.button,
        onDarkBackground
          ? closeXCss.hasDarkBackground
          : closeXCss.hasLightBackground,
        (() => {
          switch (size) {
            case ButtonSize.XSMALL:
              return closeXCss.xsmall;
            case ButtonSize.SMALL:
              return closeXCss.small;
            case ButtonSize.MEDIUM:
              return closeXCss.medium;
            case ButtonSize.LARGE:
              return closeXCss.large;
          }
        })(),
      )}
      data-arbiter="RedoButtonCloseX"
      onClick={onclick}
      style={style}
      type="button"
    >
      <div aria-hidden="true" className={closeXCss.iconWrapper}>
        <XIcon />
      </div>
    </button>
  );
}
